import Typography from '@alltrails/shared/denali/components/Typography';
import * as styles from './styles/styles.module.scss';

type CardGridSectionProps = {
  header: React.ReactNode;
  subheader?: React.ReactNode;
  children: React.ReactNode[];
};

const CardGridSection = ({ header, subheader, children }: CardGridSectionProps) => (
  <div className={styles.container}>
    <Typography variant="heading700">{header}</Typography>
    {subheader && (
      <Typography className={styles.subheader} variant="paragraph300">
        {subheader}
      </Typography>
    )}
    <div className={styles.cardsContainer}>{children}</div>
  </div>
);

export default CardGridSection;
